import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/image/StateofGTSLogoWhite 3.png';

function Main() {
  const [activeBotId, setActiveBotId] = useState('omni');

  // Get active bot ID from localStorage
  useEffect(() => {
    const getActiveBotId = () => {
      try {
        const stored = localStorage.getItem('gts.header.variant');
        if (stored && ['aws', 'genesys', 'omni', '8x8'].includes(stored)) {
          return stored;
        }
      } catch {}
      return 'omni'; // Default
    };

    setActiveBotId(getActiveBotId());

    // Listen for changes to the bot variant
    const handleStorageChange = (e) => {
      if (e.key === 'gts.header.variant') {
        setActiveBotId(getActiveBotId());
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check periodically in case localStorage is updated in same window
    const interval = setInterval(() => {
      const current = getActiveBotId();
      if (current !== activeBotId) {
        setActiveBotId(current);
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [activeBotId]);

  // Get phone number based on active bot
  const getPhoneNumber = () => {
    switch (activeBotId) {
      case '8x8':
        return { display: '(423) 466-4440', href: 'tel:+14234664440' };
      case 'aws':
        return { display: '(920) 945-6191', href: 'tel:+19209456191' };
      case 'genesys':
      case 'omni':
      default:
        // Default phone number (from Footer - current number for Genesys and Omni)
        return { display: '(423) 834-7642', href: 'tel:+14238347642' };
    }
  };

  const phoneInfo = getPhoneNumber();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
        <section className="footer">
            <div className="footer-inner">
                <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                    <div className="footer-widget-logo">
                        <Link to="/" onClick={scrollToTop}>
                          <img src={Logo} className="img-fluid" alt="img-25" />
                        </Link>
                    </div>
                    
                    <div className="footer-widget-text">
                        <p>
                        Connect with us at the State of GTS
                        </p>
                    </div>
                   
                    <div className="footer-widget-socials">
                        <a href="https://x.com/GTS_CX_AI">
                            <i className="fa-brands fa-twitter" />
                        </a>
                        <a href="https://www.facebook.com/p/Global-Technology-Solutions-GTS-100070807695327/">
                            <i className="fa-brands fa-facebook" />
                        </a>
                        <a href="https://www.linkedin.com/company/global-tek-solutions-llc/">
                            <i className="fa-brands fa-linkedin" />
                        </a>
                        <a href="https://www.instagram.com/bots_and_bytes">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </div>
                   
                    </div>
                    
                    <div className="col-lg-3">
                    <div className="footer-widget">
                        <div className="footer-widget-explore">
                        <h4 className="footer-widget-title">Explore</h4>
                        <ul className="list-unstyled">
                            {/* <li>
                            <Link to="/services">Services</Link>
                            </li> */}
                            <li>
                            <Link to="/about" onClick={scrollToTop}>About Us</Link>
                            </li>
                            {/* <li>
                            <Link to="/news">News</Link>
                            </li>
                            <li>
                            <Link to="/events">Events</Link>
                            </li> */}
                            <li>
                            <Link to="/contact" onClick={scrollToTop}>Contact Us</Link>
                            </li>
                            <li>
                            <Link to="/report-issue" onClick={scrollToTop}>Report Issue</Link>
                            </li>
                            <li>
                            <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link>
                            </li>
                        </ul>
                        </div>
                    </div>
                    </div>

                    <div className="col-lg-3">
                    <div className="footer-widget">
                        <div className="footer-widget-department">
                        <h4 className="footer-widget-title">Departments</h4>
                        <ul className="list-unstyled">
                            <li>
                            <Link to="/department/dmv">Motor Vehicles</Link>
                            </li>
                            <li>
                            <Link to="/department/health">Health & Human Services</Link>
                            </li>
                            <li>
                            <Link to="/department/education">Education</Link>
                            </li>
                            <li>
                            <Link to="/department/employment">Employment & Workforce Development</Link>
                            </li>
                            <li>
                            <Link to="/department/housing">Housing & Community Development</Link>
                            </li>
                            <li>
                            <Link to="/department/family-services">Family & Children Services</Link>
                            </li>
                            <li>
                            <Link to="/department/public-safety">Public Safety</Link>
                            </li>
                            <li>
                            <Link to="/department/senior-services">Senior Services</Link>
                            </li>
                            <li>
                            <Link to="/department/veterans">Veterans Affairs</Link>
                            </li>
                            <li>
                            <Link to="/department/emergency">Emergency Management</Link>
                            </li>
                            <li>
                            <Link to="/department/technology">Innovation & Technology</Link>
                            </li>
                        </ul>
                        </div>
                    </div>
                    
                    </div>
                    
                    <div className="col-lg-3">
                    <div className="footer-widget">
                        <div className="footer-widget-contact">
                        <h4 className="footer-widget-title">Contact</h4>
                        <p>
                            State of GTS
                            <br />
                            123 State St,
                            <br />
                            Washington, GT 12345
                        </p>
                        </div>
                       
                        <div className="footer-widget-contact-list">
                        <i className="fa-solid fa-envelope" />
                        <div className="footer-widget-contact-item">
                            <Link to="mailto:hello@gts.gov" onClick={scrollToTop}>hello@gts.gov</Link>
                        </div>
                        
                        </div>
                        
                        <div className="footer-widget-contact-list">
                        <i className="fa-solid fa-phone" />
                        <div className="footer-widget-contact-item">
                            <Link to={phoneInfo.href} onClick={scrollToTop}>{phoneInfo.display}</Link>
                        </div>
                        
                        </div>
                        
                        <div className="footer-widget-contact-list">
                        <i className="fa-solid fa-clock" />
                        <div className="footer-widget-contact-item">
                            <span style={{ marginLeft: '10px', fontSize: '15px', color: 'var(--thm-white)', fontFamily: 'var(--thm-font)', fontWeight: 700 }}>
                                Open Hours: Mon - Fri 8.00 am - 6.00 pm
                            </span>
                        </div>
                        
                        </div>
                        
                    </div>
                    
                    </div>
                    
                </div>
                
                </div>
                
            </div>
            <div className="bottom-footer">
                <div className="conatiner">

                    <p>© Copyright 2025 by the State of GTS </p>

                </div>
                
            </div>
        </section>
    </>
  )
}

export default Main;
